<template>
  <div class="order-query-container">
    <!-- 按钮区域 - 放置在查询表单上方右侧 -->
    <div class="button-container" style="margin-bottom: 16px; text-align: right;">
      <a-button type="primary" @click="handleQuery">查询</a-button>
      <a-button style="margin-left: 8px;" @click="handleReset">重置</a-button>
      <a-button style="margin-left: 8px;" icon="download" />
      <vxe-select
        v-model="queryCondition"
        style="width: 120px; margin-left: 8px;"
        placeholder="查询条件"
      >
        <vxe-option value="">请选择查询条件</vxe-option>
      </vxe-select>
    </div>

    <!-- 查询条件区域 -->
    <div class="query-condition">
      <div class="condition-wrapper" :class="{ 'collapsed': isCollapsed }">
        <!-- 第一行查询条件 -->
        <a-row :gutter="24">
          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">订单号：</label>
              <vxe-input
                v-model="orderNo"
                placeholder="请输入订单号"
                style="width: 100%;"
              ></vxe-input>
            </div>
          </a-col>

          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">订单类型：</label>
              <vxe-select
                v-model="orderType"
                placeholder="请选择订单类型"
              >
                <vxe-option value="">不限</vxe-option>
                <vxe-option value="normal">普通订单</vxe-option>
                <vxe-option value="return">退货订单</vxe-option>
              </vxe-select>
            </div>
          </a-col>

          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">原快递单号：</label>
              <vxe-input
                v-model="originalExpressNo"
                placeholder="请输入原快递单号"
                style="width: 100%;"
              ></vxe-input>
            </div>
          </a-col>

          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">转发快递单号：</label>
              <vxe-input
                v-model="forwardExpressNo"
                placeholder="请输入转发快递单号"
                style="width: 100%;"
              ></vxe-input>
            </div>
          </a-col>

        </a-row>

        <!-- 第二行查询条件 -->
        <a-row :gutter="24" style="margin-top: 16px;">
          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">操作时间：</label>
              <a-date-picker
                v-model="operateTime"
                style="width: 100%;"
                placeholder="请选择操作时间"
              ></a-date-picker>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">货主编码：</label>
              <a-input-group>
                <vxe-input
                  v-model="ownerCode"
                  placeholder="请输入货主编码"
                  style="width: calc(100% - 32px);"
                ></vxe-input>
                <a-icon
                  type="search"
                  style="float: right; margin-top: 5px; color: #1890ff; cursor: pointer; width: 32px; text-align: center;"
                ></a-icon>
              </a-input-group>
            </div>
          </a-col>

          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">原承运商：</label>
              <vxe-select
                v-model="originalCarrier"
                placeholder="请选择原承运商"
              >
                <vxe-option value="">不限</vxe-option>
                <vxe-option value="sf">顺丰</vxe-option>
                <vxe-option value="yd">韵达</vxe-option>
                <vxe-option value="zt">中通</vxe-option>
              </vxe-select>
            </div>
          </a-col>

          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">转发承运商：</label>
              <vxe-select
                v-model="forwardCarrier"
                placeholder="请选择转发承运商"
              >
                <vxe-option value="">不限</vxe-option>
                <vxe-option value="sf">顺丰</vxe-option>
                <vxe-option value="yd">韵达</vxe-option>
                <vxe-option value="zt">中通</vxe-option>
              </vxe-select>
            </div>
          </a-col>

        </a-row>

        <!-- 第三行查询条件 -->
        <a-row :gutter="24" style="margin-top: 16px;">
          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">操作人：</label>
              <a-input-group>
                <vxe-input
                  v-model="operator"
                  placeholder="请输入操作人"
                  style="width: calc(100% - 32px);"
                ></vxe-input>
                <a-icon
                  type="search"
                  style="float: right; margin-top: 5px; color: #1890ff; cursor: pointer; width: 32px; text-align: center;"
                ></a-icon>
              </a-input-group>
            </div>
          </a-col>

          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">仓库：</label>
              <vxe-select
                v-model="warehouse"
                style="width: 100%;"
                placeholder="请选择仓库"
              >
                <vxe-option value="">不限</vxe-option>
                <vxe-option value="sh">上海仓</vxe-option>
                <vxe-option value="bj">北京仓</vxe-option>
                <vxe-option value="gz">广州仓</vxe-option>
              </vxe-select>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">状态：</label>
              <vxe-select
                v-model="status"
                placeholder="请选择状态"
              >
                <vxe-option value="">不限</vxe-option>
                <vxe-option value="pending">待处理</vxe-option>
                <vxe-option value="processed">已处理</vxe-option>
                <vxe-option value="cancelled">已取消</vxe-option>
              </vxe-select>
            </div>
          </a-col>

          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">创建时间范围：</label>
              <a-range-picker
                v-model="createTimeRange"
                style="width: 100%;"
                placeholder="请选择创建时间范围"
              ></a-range-picker>
            </div>
          </a-col>

        </a-row>        <!-- 第三行查询条件 -->
        <a-row :gutter="24" style="margin-top: 16px;">

          <a-col :span="6">
            <div class="form-item">
              <label class="form-label">更新时间范围：</label>
              <a-range-picker
                v-model="updateTimeRange"
                style="width: 100%;"
                placeholder="请选择更新时间范围"
              ></a-range-picker>
            </div>
          </a-col>
        </a-row>

      </div>

      <!-- 收起/展开按钮 -->
      <div style="text-align: center; margin-top: 10px;">
        <a-button
          type="link"
          @click="toggleCollapse"
          style="color: #1890ff;"
        >
          {{ isCollapsed ? '展开' : '收起' }}
          <a-icon :type="isCollapsed ? 'down' : 'up'" />
        </a-button>
      </div>
    </div>

    <!-- 表格区域 -->
    <div class="table-container">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
        bordered
        :loading="loading"
      >
        <!-- 自定义空状态 -->
        <template #empty>
          <div style="text-align: center; padding: 50px 0;">
            <a-icon type="inbox" style="font-size: 48px; color: #ccc; margin-bottom: 16px;" />
            <p style="color: #ccc;">请先查询</p>
          </div>
        </template>

        <!-- 序号列 -->
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.dataIndex === 'index'">
            {{ index + 1 }}
          </template>
        </template>
      </a-table>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-container">
      <div style="float: left; line-height: 32px;">
        跳转至
        <vxe-input
          v-model="currentPage"
          style="width: 60px; display: inline-block; margin: 0 8px;"
          @change="handlePageChange"
        ></vxe-input>
        页
        <vxe-select
          v-model="pageSize"
          @change="handlePageSizeChange"
        >
          <vxe-option value="10">10</vxe-option>
          <vxe-option value="20">20</vxe-option>
          <vxe-option value="50">50</vxe-option>
          <vxe-option value="100">100</vxe-option>
        </vxe-select>
      </div>

      <div style="float: right;">
        <a-pagination
          :current="currentPage"
          :page-size="pageSize"
          :total="total"
          :show-size-changer="false"
          :show-quick-jumper="false"
          :show-total="(total) => `共 ${total} 条`"
          @change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 查询条件
      orderNo: '',
      orderType: '',
      originalExpressNo: '',
      forwardExpressNo: '',
      operateTime: null,
      ownerCode: '',
      originalCarrier: '',
      forwardCarrier: '',
      operator: '',
      warehouse: '',
      status: '',
      createTimeRange: [],
      updateTimeRange: [],
      queryCondition: '',

      // 表格数据
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 60,
          fixed: 'left'
        },
        {
          title: '仓库',
          dataIndex: 'warehouse',
          sorter: true
        },
        {
          title: '货主',
          dataIndex: 'owner',
          sorter: true
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          sorter: true
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          sorter: true
        },
        {
          title: '原快递单号',
          dataIndex: 'originalExpressNo',
          sorter: true
        },
        {
          title: '原承运商',
          dataIndex: 'originalCarrier',
          sorter: true
        },
        {
          title: '转发快递单号',
          dataIndex: 'forwardExpressNo',
          sorter: true
        },
        {
          title: '转发承运商',
          dataIndex: 'forwardCarrier',
          sorter: true
        },
        {
          title: '操作人编码',
          dataIndex: 'operatorCode',
          sorter: true
        },
        {
          title: '操作人名称',
          dataIndex: 'operateName',
          sorter: true
        },
        {
          title: '操作时间',
          dataIndex: 'operateTime',
          sorter: true
        },
        {
          title: '虚拟货主',
          dataIndex: 'storte',
          sorter: true
        }
      ],
      tableData: [],
      loading: false,
      total: 0,

      // 分页参数
      currentPage: 1,
      pageSize: 50,

      // 折叠状态
      isCollapsed: true
    };
  },
  methods: {
    // 处理查询
    handleQuery() {
      this.loading = true;
      // 模拟查询请求
      setTimeout(() => {
        this.loading = false;
        // 模拟数据
        this.tableData = Array(this.pageSize).fill().map((_, index) => ({
          key: index,
          warehouse: ['上海仓', '北京仓', '广州仓'][Math.floor(Math.random() * 3)],
          owner: `货主${Math.floor(Math.random() * 100)}`,
          orderNo: `ORD${Math.floor(Math.random() * 1000000)}`,
          orderType: ['普通订单', '退货订单'][Math.floor(Math.random() * 2)],
          originalExpressNo: `EXP${Math.floor(Math.random() * 1000000)}`,
          originalCarrier: ['顺丰', '韵达', '中通'][Math.floor(Math.random() * 3)],
          forwardExpressNo: `FWD${Math.floor(Math.random() * 1000000)}`,
          forwardCarrier: ['顺丰', '韵达', '中通'][Math.floor(Math.random() * 3)],
          operatorCode: `OP${Math.floor(Math.random() * 100)}`,
          operateTime: new Date(Date.now() - Math.floor(Math.random() * 86400000 * 30)).toLocaleString(),
          status: ['待处理', '已处理', '已取消'][Math.floor(Math.random() * 3)]
        }));
        this.total = 235; // 模拟总条数
      }, 500);
    },

    // 处理重置
    handleReset() {
      // 重置所有查询条件
      this.orderNo = '';
      this.orderType = '';
      this.originalExpressNo = '';
      this.forwardExpressNo = '';
      this.operateTime = null;
      this.ownerCode = '';
      this.originalCarrier = '';
      this.forwardCarrier = '';
      this.operator = '';
      this.warehouse = '';
      this.status = '';
      this.createTimeRange = [];
      this.updateTimeRange = [];
      this.queryCondition = '';

      this.currentPage = 1;
      this.tableData = [];
    },

    // 切换折叠状态
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },

    // 处理页码变化
    handlePageChange(page) {
      this.currentPage = page;
      this.handleQuery(); // 重新查询
    },

    // 处理页大小变化
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1; // 重置到第一页
      this.handleQuery(); // 重新查询
    }
  }
};
</script>

<style scoped>
.order-query-container {
  padding: 16px;
  background-color: #fff;
  min-height: 100%;
}

.query-condition {
  border: 1px solid #e8e8e8;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
}

.condition-wrapper {
  transition: max-height 0.3s ease;
  max-height: 1000px;
  overflow: hidden;
}

.condition-wrapper.collapsed {
  max-height: 60px;
  overflow: hidden;
}

.table-container {
  margin-bottom: 16px;
}

.pagination-container {
  overflow: hidden;
  padding: 16px;
  border-top: 1px solid #e8e8e8;
}

/* 表单项目样式 */
.form-item {
  display: flex;
  align-items: center;
}

.form-label {
  width: 170px;
  text-align: right;
  margin-right: 8px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

/* 隐藏表格排序图标默认样式 */
::v-deep .ant-table-column-sorter {
  display: none;
}

/* 表格列标题添加排序指示 */
::v-deep .ant-table-column-title:after {
  font-size: 12px;
  color: #ccc;
  margin-left: 4px;
  cursor: pointer;
}

/* 调整日期选择器图标位置 */
::v-deep .ant-calendar-picker-icon {
  right: 8px !important;
}

/* 输入框组样式调整 */
::v-deep .ant-input-group {
  display: flex;
  width: 100%;
}
</style>
